export const ROLE_ADMIN = '1';
export const ROLE_TRADER = '2';
export const ROLE_CONTROL_DOCUMENT = '3';



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/config/roles.config.ts